import React, { ReactNode } from 'react';
import { Flex } from '@balance-web/flex';

export const Header = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      gap="xsmall"
      paddingX="large"
      paddingTop="medium"
      justifyContent="space-between"
    >
      {children}
    </Flex>
  );
};
